export default __webpack_public_path__ + "static/media/Helm of the Beyond.6dbe687f.jpg";